<mat-list-item class="mat-elevation-z2">
  <img matListAvatar [src]="item?.produto?.foto?.url || 'assets/images/placeholder.png'" />

  <div mat-line>{{ item?.produto?.tituloComposto }}</div>
  <div mat-line>{{ item?.produto?.codProduto }}</div>
  <div mat-line>Unidade: {{ item.valorUnitario | currency: 'BRL' }}</div>

  <div mat-line>
    Qtd:
    <div class="increment-decrement-btn">
      <button mat-icon-button (click)="decrementItem(item)">
        <mat-icon>remove</mat-icon>
      </button>
      {{ item.quantidade }}
      <button mat-icon-button (click)="incrementItem(item)">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>

  <div mat-line>Total: {{ item.valorTotalDoItemSemFrete | currency: 'BRL' }}</div>
  <div mat-line>
    <button type="button" name="remover-item" (click)="removerItem(item)" mat-button color="warn">Remover item</button>
  </div>
</mat-list-item>
